import { render, staticRenderFns } from "./RevenueServiceInvoiceList.vue?vue&type=template&id=f4279e96&scoped=true"
import script from "./RevenueServiceInvoiceList.vue?vue&type=script&lang=js"
export * from "./RevenueServiceInvoiceList.vue?vue&type=script&lang=js"
import style0 from "./RevenueServiceInvoiceList.vue?vue&type=style&index=0&id=f4279e96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4279e96",
  null
  
)

export default component.exports